export default [
  {
    title: "Monitoring",
    icon: "GitCommitIcon",
    tagVariant: "success",
    children: [
      {
        title: "Outgoing Messages",
        route: "monitoring-outgoing",

        resource: "Outgoing",
        action: "View",
      },
      {
        title: "Incoming Messages",
        route: "monitoring-incoming",
        resource: "Incoming",
        action: "View",
      },
      {
        title: "Transaction Log",
        route: "monitoring-transaction",
        resource: "Transaction",
        action: "View",
      },
      {
        title: "Last Paid Order",
        route: "lastPaid-index",
        resource: "LastPaid",
        action: "View",
      },
    ],
  },
  {
    title: "User Guide Media",
    icon: "BookIcon",
    tagVariant: "light-warning",
    route: "Order-View",
    resource: "UserGuide",
    action: "View",
  },
];
